import React from "react";
import BgImg from "../assests/backgroundImage2.avif";
import { Close } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import caseImg1 from "../assests/caseImage1.avif";
import caseImg2 from "../assests/caseImage2.gif";
import caseImg3 from "../assests/caseImage3.webp";
import caseImg4 from "../assests/caseImage4.webp";


const CaseStudies = () => {
    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(450));

    const styles = {
        container: {
            backgroundImage: `url(${BgImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            color: 'white',
            textAlign: 'center',
            boxSizing: 'border-box',
            overflow: 'hidden',
        },
        content: {
            padding: isSmall ? '10px' : '20px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        innerBox: {
            width: isMobile ? '95%' : '80%',
            backgroundColor: 'rgba(0, 0, 0, 1)',
            padding: isMobile ? '10px' : '20px',
            borderRadius: '15px',
            border: '1px solid #2c2a25',
            boxSizing: 'border-box',
            marginTop: 20,
            border: '2px dashed #ffd125',

        },
        blackBox: {
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
        },
        leftBox: {
            width: isMobile ? '100%' : '45%',
            textAlign: 'left',
            padding: isMobile ? '10px' : '20px',
            boxSizing: 'border-box',
            borderRadius: '15px'
        },
        rightBox: {
            width: isMobile ? '100%' : '45%',
            padding: isMobile ? '10px' : '20px',
            boxSizing: 'border-box',
            borderRadius: '15px',
            textAlign: 'left',
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={{ width: isMobile ? '90%' : isBig ? '80%' : '60%', marginTop: 50 }}>
                    <motion.div
                        initial={{ opacity: 0, y: 50, scale: 0.6 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                        viewport={{ amount: 0.5 }}
                        style={{ fontSize: isMobile ? '22px' : '45px', fontWeight: 700, color: '#000' }}
                    >
                        These Are Various Allied Case Studies
                    </motion.div>
                </div>

                <motion.div
                    style={{ marginTop: '20px', color: '#000', width: isMobile ? '90%' : isBig ? '70%' : '40%', lineHeight: '1.5' }}
                    initial={{ opacity: 0, y: 50, scale: 0.6 }}
                    whileInView={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: 0.5 }}
                >
                    Our partners brands have grown by 30-40% MoM past the revenue ceiling & added an extra $50k/Month profitably in less than 90 days
                </motion.div>


                <motion.div
                    initial={{ opacity: 0, x: isMobile ? -100 : -500, scale: 0.6 }}
                    whileInView={{ opacity: 1, x: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: isMobile ? 0.1 : 0.5, once: true }}
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            {
                                isMobile ?
                                    <>
                                        <img src={caseImg1} style={{ width: '100%' }} ></img>

                                    </>
                                    :
                                    <>
                                        <h4>WOMEN'S APPAREL BRAND</h4>

                                        <h2>From ₹25.7L/Month to ₹72L/Month</h2>

                                        <div style={{ lineHeight: 1.5 }}>
                                            First starting out with them in March 2024, the brand used to hit ₹25L around per month & was stuck at the same revenue roof since last 4-5 months. 2 of the primary metrics were disturbed i.e. conversion rates + CPMs. Cracking a solid zero-to-one ₹1,999 offer improved the conversion rates by 25% & having a solid media buying strategy helped us bring down CPMs by 40% approx. But the major goal was to give a next-level user experience to consumers, where we were able to crack by 3rd month, and 72% of revenue growth in 3rd month is testament to it. Brand's ROI & contribution margins drastically improved by 22% using our profit optimisation strategies. Finally, the brand is now growing by 30-40% MoM. (Quick Insight - DPA + cost caps work so well for women apparel)
                                        </div>
                                    </>
                            }

                        </div>

                        <div style={styles.rightBox}>
                            {
                                isMobile ?
                                    <>
                                        <h4>WOMEN'S APPAREL BRAND</h4>

                                        <h2>From ₹25.7L/Month to ₹72L/Month</h2>

                                        <div style={{ lineHeight: 1.5 }}>
                                            First starting out with them in March 2024, the brand used to hit ₹25L around per month & was stuck at the same revenue roof since last 4-5 months. 2 of the primary metrics were disturbed i.e. conversion rates + CPMs. Cracking a solid zero-to-one ₹1,999 offer improved the conversion rates by 25% & having a solid media buying strategy helped us bring down CPMs by 40% approx. But the major goal was to give a next-level user experience to consumers, where we were able to crack by 3rd month, and 72% of revenue growth in 3rd month is testament to it. Brand's ROI & contribution margins drastically improved by 22% using our profit optimisation strategies. Finally, the brand is now growing by 30-40% MoM. (Quick Insight - DPA + cost caps work so well for women apparel)
                                        </div>
                                    </>
                                    :
                                    <img src={caseImg1} style={{ width: '100%' }} ></img>

                            }
                        </div>
                    </div>
                </motion.div>


                <motion.div
                    initial={{ opacity: 0, x: isMobile ? 100 : 500, scale: 0.6 }}
                    whileInView={{ opacity: 1, x: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: isMobile ? 0.1 : 0.5, once: true }}
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            <img src={caseImg2} style={{ width: '100%' }} ></img>
                        </div>

                        <div style={{ ...styles.rightBox, textAlign: 'left', lineHeight: 1.5 }}>
                            <h4>JEWELLERY & ACCESSORIES BRAND</h4>

                            <h2>From ₹5.7L/Month to ₹87L/Month</h2>

                            <div >
                                The jewellery & accessories brand never going beyond 6L+ months started working with us in March & since then the growth has been consistent besides profitability. The biggest concern before we started for the founder was that the brand isn't scaling as smoothly as he wanted & ROAS use to be around 5-6X that time. With out efforts on content, ads & growth consulting, we improved the ROAS to 6-7X in first 3 months & then scaled to 85L+ within 10 months. Since we started brand has almost generated a 4.4Cr in profitable revenue.
                            </div>
                        </div>
                    </div>
                </motion.div>



                <motion.div
                    initial={{ opacity: 0, x: isMobile ? -100 : -500, scale: 0.6 }}
                    whileInView={{ opacity: 1, x: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: isMobile ? 0.1 : 0.5, once: true }}
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            {
                                isMobile ?
                                    <img src={caseImg3} style={{ width: '100%' }} ></img>
                                    :
                                    <>
                                        <h4>FASHION BRAND</h4>

                                        <h2>₹5.84Cr Generated in Last 12 Months</h2>

                                        <div style={{ lineHeight: 1.5 }}>
                                            In the past year, we helped a fashion brand in India generate ₹5.84 Cr in revenue by significantly improving their key metrics. We boosted their conversion rate from 0.9% to 1.25%, reduced CPMs by 35%, increased their average order value from ₹550 to ₹750, and raised click-through rates from 1.2% to 1.8%. These improvements led to a 2.9X ROAS, up from 1.9X, and enhanced their contribution margin by 35%. Our strategic focus on creative pipeline, diverse content, and effective media buying fueled this aggressive growth and profitability. In wellness, best is to focus on AOV & pain points + social proof driven advertising to maximise profitable revenue.
                                        </div>
                                    </>
                            }
                        </div>

                        <div style={styles.rightBox}>
                            {
                                isMobile ?

                                    <>
                                        <h4>FASHION BRAND</h4>

                                        <h2>₹5.84Cr Generated in Last 12 Months</h2>

                                        <div style={{ lineHeight: 1.5 }}>
                                            In the past year, we helped a fashion brand in India generate ₹5.84 Cr in revenue by significantly improving their key metrics. We boosted their conversion rate from 0.9% to 1.25%, reduced CPMs by 35%, increased their average order value from ₹550 to ₹750, and raised click-through rates from 1.2% to 1.8%. These improvements led to a 2.9X ROAS, up from 1.9X, and enhanced their contribution margin by 35%. Our strategic focus on creative pipeline, diverse content, and effective media buying fueled this aggressive growth and profitability. In wellness, best is to focus on AOV & pain points + social proof driven advertising to maximise profitable revenue.
                                        </div>
                                    </>
                                    :
                                    <img src={caseImg3} style={{ width: '100%' }} ></img>
                            }
                        </div>

                    </div>
                </motion.div>



                <motion.div
                    initial={{ opacity: 0, x: isMobile ? 100 : 500, scale: 0.6 }}
                    whileInView={{ opacity: 1, x: 0, scale: 1 }}
                    transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                    viewport={{ amount: isMobile ? 0.1 : 0.5, once: true }}
                    style={styles.innerBox}
                >
                    <div style={styles?.blackBox}>
                        <div style={styles.leftBox}>
                            <img src={caseImg4} style={{ width: '100%' }} ></img>
                        </div>

                        <div style={{ ...styles.rightBox, textAlign: 'left', lineHeight: 1.5 }}>
                            <h4>ETHNIC BRAND</h4>

                            <h2>From ₹22L/Month to ₹51L/Month in 90 Days</h2>

                            <div >
                                This Ethnic brand came to us stuck at ₹20-22L months, with their Facebook and Google Ads never reaching over a 1.7x ROAS. Struggling to scale with poor performance, this client was relying on repeat customers to generate sales & some organic sales as well.
                            </div>

                            <div style={{ marginTop: 40 }}>
                                Their results: Since partnering with GroMedia, in 3 months we've achieved their first ₹50L+ sales month and successfully improved their blended ROAS on Meta & Google to 2.4x
                            </div>
                        </div>
                    </div>
                </motion.div>



            </div>
        </div >
    );
};


export default CaseStudies;
